var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76471 17.8238C1.27941 17.8238 0.863825 17.6509 0.517942 17.305C0.17206 16.9591 -0.000586737 16.5438 1.49805e-06 16.0591V3.70617H1.76471V16.0591H11.4706V17.8238H1.76471ZM5.29412 14.2944C4.80882 14.2944 4.39324 14.1215 4.04735 13.7756C3.70147 13.4297 3.52882 13.0144 3.52941 12.5297V1.94146C3.52941 1.45617 3.70235 1.04058 4.04824 0.6947C4.39412 0.348818 4.80941 0.176171 5.29412 0.176759H13.2353C13.7206 0.176759 14.1362 0.3497 14.4821 0.695583C14.8279 1.04147 15.0006 1.45676 15 1.94146V12.5297C15 13.015 14.8271 13.4306 14.4812 13.7765C14.1353 14.1223 13.72 14.295 13.2353 14.2944H5.29412Z",
    fill: "#2E2E2E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.84a700fb9dee8f4bd3f636ed832f1b44.svg";